class PickupAvailability extends ModalOpener {
  constructor() {
    super();
  }

  onButtonClick(button) {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const modal = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('modal-dialog');
        document.body.appendChild(modal);
        setTimeout(() => {
          super.onButtonClick(button);
        }, 300);
      })
      .catch((error) => console.log(error));
  }

  connectedCallback() {
    this.button = this.querySelector('button');

    if (!this.button) return;

    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }
}

customElements.define('pickup-availability', PickupAvailability);
